/**
 * @description defines SECCON custom styles and default properties for material ui components
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';

/**
 * Adapter for the Material UI Link component that joins the component with the React Router Link component. This is what
 *  makes it possible for the Material UI Link component to integrate with the react-router's router.
 */
const LinkBehavior = React.forwardRef((props, ref) => {
  const { href, ...other } = props;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <RouterLink ref={ref} to={href} {...other} />;
});

LinkBehavior.propTypes = {
  href: PropTypes.string
};

LinkBehavior.defaultProps = {
  href: null
};

const theme = createTheme({
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior
      }
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior
      }
    }
  },
  palette: {
    // Brand primary color
    seccon: {
      main: '#d96729',
      light: '#dd763e',
      dark: '#c55c23',
      contrastText: '#ffffff'
    }
  }
});

export default theme;
